let sb = require('@sb/util')
import FormAttachment from './FormAttachment.js'

export default {
	props: ['ev'],

	render () {
		let byType = sb.get(this.ev, 'by.type')
		if (byType === 'user') return

		let forms = []
		let attachments = sb.get(this.ev, 'data.message.attachments') || []
		sb.each(attachments, att => {
			if (!att) return
			if (att.type !== 'form' && att.type !== 'ask_info_form') return
			att.form._type = att.type
			forms.push(att.form)
		})

		let $forms = sb.map(forms, (form, formIndex) => {
			return <FormAttachment vOn:submit={this.onSubmit} ref="form" key={formIndex} form={form} ev={this.ev} />
		})

		return <div class="message-agent">{$forms}</div>
	},
	methods: {
		onSubmit () {
			this.$emit('submit')
		},

		focus () {
			var $form = this.$refs.form
			if ($form) $form.focus()
		},
	},
}
